import { useRef, useState } from "react";
import { MoveHorizontal } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export const BeforeAfter = ({ before, after, testid }) => {
  const { t } = useLang();
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const p = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(100, Math.max(0, p)));
  };

  return (
    <div
      ref={ref}
      data-testid={testid}
      className="relative w-full h-72 sm:h-96 overflow-hidden rounded-2xl border border-white/10 select-none group"
      onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
      onTouchMove={(e) => move(e.touches[0].clientX)}
    >
      {/* After (base) */}
      <img
        src={after}
        alt={t.gallery.after}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover"
        draggable={false}
      />
      <span className="absolute top-3 right-3 z-10 rounded-full bg-brand px-3 py-1 text-xs font-semibold text-white">
        {t.gallery.after}
      </span>

      {/* Before (clipped) */}
      <div
        className="absolute inset-0 overflow-hidden"
        style={{ width: `${pos}%` }}
      >
        <img
          src={before}
          alt={t.gallery.before}
          loading="lazy"
          className="absolute inset-0 h-full object-cover"
          style={{ width: ref.current?.offsetWidth || "100%", maxWidth: "none" }}
          draggable={false}
        />
        <span className="absolute top-3 left-3 rounded-full bg-black/70 backdrop-blur px-3 py-1 text-xs font-semibold text-white">
          {t.gallery.before}
        </span>
      </div>

      {/* Handle */}
      <div
        className="absolute top-0 bottom-0 z-10 flex items-center justify-center"
        style={{ left: `calc(${pos}% - 22px)` }}
      >
        <div className="absolute top-0 bottom-0 left-1/2 w-0.5 -translate-x-1/2 bg-white/80" />
        <div className="h-11 w-11 rounded-full bg-brand border-[3px] border-white grid place-items-center shadow-lg">
          <MoveHorizontal className="h-5 w-5 text-white" />
        </div>
      </div>

      <input
        type="range"
        min="0"
        max="100"
        value={pos}
        onChange={(e) => setPos(Number(e.target.value))}
        aria-label="Before after slider"
        data-testid={`${testid}-range`}
        className="ba-range absolute inset-0 w-full h-full opacity-0 z-20"
      />
    </div>
  );
};
